import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FootNotes } from "@/components/FootNotes/FootNotes.component";
import { PaywallAddTrial } from "@/components/Paywall/_components/PaywallAddTrial/PaywallAddTrial.component";
import { PaywallTitle } from "@/components/Paywall/_components/PaywallTitle/PaywallTitle.component";
import { ProductsContainer } from "@/components/ProductsContainer/ProductsContainer.component";
type AuthenticatedPaywallProps = {
  readonly position?: string;
  readonly className?: string;
};
export function AuthenticatedPaywall(t0) {
  const $ = _c(8);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex flex-col space-y-5 border-smoke border-t border-solid pt-5 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PaywallTitle model={{
      da: "Du er logget ind, men du har ikke et aktivt abonnement",
      de: "Sie sind eingeloggt, aber Sie haben kein aktives Abonnement",
      en: "You are logged in, but you do not have an active subscription",
      no: "Du er logget inn, men du har ikke et aktivt abonnement",
      sv: "Du \xE4r inloggad, men har inte ett aktivt abonnemang"
    }} />;
    t3 = <ProductsContainer position="pw" promoPosition="paywall" variant="paywall" />;
    t4 = <PaywallAddTrial />;
    t5 = <FootNotes />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1) {
    t6 = <div className={t1} data-testid="authenticated-paywall">{t2}{t3}{t4}{t5}</div>;
    $[6] = t1;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}